var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"card_title",class:[{'end': _vm.isShowClose}, {'no-border': _vm.isNoBorder}]},[_c('p',{staticClass:"text_color_primary text_size_18 text_bold",attrs:{"title":_vm.title}},[_vm._t("default")],2),(_vm.isShowClose)?_c('i',{staticClass:"iconfont iconshanchu close",on:{"click":_vm.close}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a64dcaea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/border-title.vue
// module id = null
// module chunks = 